class AccountSettings.InstagramHashtagListeningRenovationView extends Backbone.View
  template: JST['backbone/templates/account_settings/topics/instagram_listening_hashtags_renovation_type']

  initialize:(renovationType)->
    @renovationType = renovationType || 'let-it-expire'

  render:->
    @$el.html(@template())
    @$('select option[value='+ @renovationType + ']').attr("selected",true);
    @
